export default __webpack_public_path__ + "static/nsandi-6cbe26926387ba3058a141f745d00a5e.png";